import { cmsApiClient } from '@/config/httpClients';
import type { CMSPage } from './schemas';
import { CMSPageSchema } from './schemas';
import type { PageSlugType } from '@/constants/page.constants';
import { logIfEmptyCMSResponse } from '@/utils/sentry';

const getCMSPageContent = async (key: PageSlugType): Promise<CMSPage> => {
  const response = await cmsApiClient
    .get<{
      data: CMSPage[];
    }>(`collections/pages/entries?filter[slug:is]=${key}`)
    .json();
  logIfEmptyCMSResponse(response);
  const parsedData = CMSPageSchema.safeParse(response.data[0]);
  if (!parsedData.success) {
    console.error('ZOD ERROR ==>', parsedData);
  }
  return response.data[0];
};

export { getCMSPageContent };
